export default __webpack_public_path__ + "static/media/add-step3.6fbf68c9.svg";